import { render } from "./NewsArticle.vue?vue&type=template&id=1355142c"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__